/**
 * Mapped to route `/371`, took from Japanese, meaning `cannot be seen`
 */
import { PureComponent } from 'react'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import styles from './SecretDashboard.css'
import { I13nDiv } from '@vzmi/ec-react-i13n'

import SimpleMain from '../../containers/SimpleMain'
import dashboardRoutes from '../../../../conf/dashboardConf'
import OperatingDashboard from './OperatingDashboard'

const HelmetSetting = () => (
  <Helmet>
    <title>營運看板</title>
  </Helmet>
)

class SecretDashboard extends PureComponent {
  render () {
    const props = this.props
    const { i13nData } = props
    return (
      <SimpleMain
        {...props}
        routes={dashboardRoutes}
        render={(mainProps) => {
          return (
            <I13nDiv
              className={styles.SecretDashboard}
              i13nModel={{ category: _.get(i13nData, 'documentGroup'), action: _.get(i13nData, 'subType') }}
            >
              <HelmetSetting />
              <div className='pure-g'>
                <div className={'pure-u-1'}>
                  <OperatingDashboard
                    {...mainProps}
                    {...props}
                  />
                </div>
              </div>
            </I13nDiv>
          )
        }}
        withSubSideBar
      />
    )
  }
}

export default SecretDashboard
